import { render } from "./FooterLinks.vue?vue&type=template&id=49f5da3f&scoped=true&ts=true"
import script from "./FooterLinks.vue?vue&type=script&lang=ts"
export * from "./FooterLinks.vue?vue&type=script&lang=ts"

import "./FooterLinks.vue?vue&type=style&index=0&id=49f5da3f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f5da3f"]])

export default __exports__